export default "__VITE_ASSET__BEv$pNsD__"